/* BOB Motion - scroll reveal + header shadow (no dependencies) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var els = [];
    if (!reduce && 'IntersectionObserver' in window) {
      var sel = 'product-card,.bob-gallery__slide,.bob-cat__tile,[class*=ai-faq-item],[class*=ai-brand-logos-card]';
      els = Array.prototype.slice.call(document.querySelectorAll(sel));
      els.forEach(function (el, i) {
        el.classList.add('bob-reveal');
        el.style.setProperty('--bob-d', (i % 4) * 90 + 'ms');
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('bob-in');
            io.unobserve(en.target);
          }
        });
      }, { threshold: 0.05 });
      els.forEach(function (el) { io.observe(el); });
    }

    function revealInView() {
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.classList.contains('bob-in')) continue;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0 && r.left < window.innerWidth && r.right > 0) {
          el.classList.add('bob-in');
        }
      }
    }

    var hdr = document.querySelector('[id*="header_section"]');
    var on = false;
    function onScroll() {
      if (hdr) {
        var s = window.scrollY > 12;
        if (s !== on) { on = s; hdr.classList.toggle('bob-hdr-shadow', s); }
      }
      revealInView();
    }
    /* capture:true also catches scrolls inside horizontal sliders */
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });
    onScroll();
    setTimeout(revealInView, 400);
    setTimeout(revealInView, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* bob-peek: hint that category slider scrolls */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function go() {
    var t = document.querySelector('.bob-cat__track');
    if (!t || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) {
          io.disconnect();
          setTimeout(function () {
            t.scrollBy({ left: 80, behavior: 'smooth' });
            setTimeout(function () { t.scrollBy({ left: -80, behavior: 'smooth' }); }, 800);
          }, 450);
        }
      });
    }, { threshold: 0.35 });
    io.observe(t);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', go); } else { go(); }
})();

(function bobFacetDe(){
  var map = {"Availability":"Verfügbarkeit","Price":"Preis","Sort by:":"Sortieren:","Sort by":"Sortieren"};
  function fix(){
    document.querySelectorAll(".facets summary span, .facets summary, .facets legend, .facets label, .facets-controls-wrapper span").forEach(function(el){
      if (el.children.length > 0) return;
      var t = el.textContent.trim();
      if (map[t]) el.textContent = map[t];
    });
  }
  fix(); setTimeout(fix, 600); setTimeout(fix, 1500);
  new MutationObserver(fix).observe(document.body, {childList:true, subtree:true});
})();

/* bob-mehr-hover */
(function(){
 var DELAY=650;
 function setup(){
  var ls=document.querySelectorAll("overflow-list");
  for(var i=0;i<ls.length;i++){ bind(ls[i]); }
 }
 function bind(ol){
  if(ol.__bobHi)return; ol.__bobHi=1;
  var t=null;
  function open(){ if(t){clearTimeout(t);t=null;} ol.classList.add("bob-open"); }
  function later(){ if(t){clearTimeout(t);} t=setTimeout(function(){ol.classList.remove("bob-open");t=null;},DELAY); }
  function now(){ if(t){clearTimeout(t);t=null;} ol.classList.remove("bob-open"); }
  ol.addEventListener("pointerover",function(e){
   var el=e.target; if(!el||!el.closest)return;
   if(el.closest("li[slot='more']")){open();return;}
   if(el.closest("li.menu-list__list-item")){now();}
  });
  ol.addEventListener("pointerout",function(e){
   var el=e.target; if(!el||!el.closest)return;
   if(el.closest("li[slot='more']")){later();}
  });
  var sr=ol.shadowRoot; if(!sr)return;
  var pan=sr.querySelector("[part=overflow]");
  if(pan){ pan.addEventListener("pointerenter",open); pan.addEventListener("pointerleave",later); }
  var hd=ol.closest(".header")||document.querySelector(".header");
  if(hd){ hd.addEventListener("pointerleave",now); }
 }
 if(document.readyState!=="loading"){setup()}else{document.addEventListener("DOMContentLoaded",setup)}
 document.addEventListener("shopify:section:load",setup);
 setTimeout(setup,1200); setTimeout(setup,3000);
})();

/* bob-reservierung */
(function(){
 var T="Reservierung \u2013 keine Online-Zahlung";
 var X="Du reservierst dein Rad unverbindlich. Bezahlt wird erst bei der Abholung im Gesch\u00e4ft in Oldenburg-Wechloy. Ein Versand ist nicht m\u00f6glich.";
 function box(){
  var d=document.createElement("div"); d.className="bob-resv";
  var b=document.createElement("strong"); b.className="bob-resv__t"; b.textContent=T;
  var p=document.createElement("span"); p.className="bob-resv__x"; p.textContent=X;
  d.appendChild(b); d.appendChild(p); return d;
 }
 function iso(d){var m=("0"+(d.getMonth()+1)).slice(-2),t=("0"+d.getDate()).slice(-2);return d.getFullYear()+"-"+m+"-"+t;}
 function termin(anchor){
  if(document.getElementById("bob-abhol"))return;
  var w=document.createElement("div"); w.className="bob-abhol";
  var l=document.createElement("label"); l.setAttribute("for","bob-abhol"); l.className="bob-abhol__l"; l.textContent="Wunsch-Abholtermin (Mo\u2013Sa)";
  var i=document.createElement("input"); i.type="date"; i.id="bob-abhol"; i.className="bob-abhol__i";
  var a=new Date(); a.setDate(a.getDate()+1); i.min=iso(a);
  var z=new Date(); z.setDate(z.getDate()+120); i.max=iso(z);
  var h=document.createElement("span"); h.className="bob-abhol__h"; h.textContent="Optional \u2013 wir best\u00e4tigen den Termin per E-Mail.";
  w.appendChild(l); w.appendChild(i); w.appendChild(h);
  anchor.parentElement.insertBefore(w,anchor);
  fetch("/cart.js").then(function(r){return r.json()}).then(function(c){
   if(c&&c.attributes&&c.attributes.Abholtermin){i.value=c.attributes.Abholtermin;}
  }).catch(function(){});
  i.addEventListener("change",function(){
   var v=i.value;
   if(v){var wd=new Date(v+"T12:00:00").getDay();
    if(wd===0){h.textContent="Sonntags haben wir geschlossen \u2013 bitte Mo\u2013Sa w\u00e4hlen."; i.value=""; return;}}
   h.textContent=v?"Termin vorgemerkt. Wir best\u00e4tigen ihn per E-Mail.":"Optional \u2013 wir best\u00e4tigen den Termin per E-Mail.";
   fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({attributes:{Abholtermin:v}})}).catch(function(){});
  });
 }
 function produkt(){
  var host=document.querySelector(".product-form-buttons");
  if(!host)return;
  if(host.parentElement.querySelector(".bob-resv"))return;
  host.parentElement.insertBefore(box(),host.nextSibling);
 }
 function warenkorb(){
  if(location.pathname.indexOf("/cart")<0)return;
  var ctas=document.querySelector(".cart__ctas");
  if(!ctas)return;
  if(!ctas.parentElement.querySelector(".bob-resv")){ctas.parentElement.insertBefore(box(),ctas);}
  termin(ctas);
 }
 function run(){ try{produkt();}catch(e){} try{warenkorb();}catch(e){} }
 if(document.readyState!=="loading"){run();}else{document.addEventListener("DOMContentLoaded",run);}
 document.addEventListener("shopify:section:load",run);
 setTimeout(run,900); setTimeout(run,2200);
 var mo=new MutationObserver(function(){ run(); });
 if(document.body){ mo.observe(document.body,{childList:true,subtree:true}); }
})();

/* bob-rv-link */
(function(){
 var data=null;
 function load(){
  if(location.pathname.indexOf('/products/')<0)return;
  fetch(location.pathname+'.js').then(function(r){return r.json()}).then(function(p){data=p}).catch(function(){});
 }
 function ziel(){
  var vid=null;
  try{vid=new URLSearchParams(location.search).get('variant')}catch(e){}
  var v=null,titel=document.title;
  if(data){titel=data.title;
   if(vid){for(var i=0;i<data.variants.length;i++){if(String(data.variants[i].id)===String(vid))v=data.variants[i]}}
   if(!v)v=data.variants[0];}
  var u='/pages/reservierung?rad='+encodeURIComponent(titel);
  if(v&&v.title&&v.title!=='Default Title'){u+='&groesse='+encodeURIComponent(v.title)}
  if(v&&v.id){u+='&vid='+encodeURIComponent(v.id)}
  u+='&ref='+encodeURIComponent(location.pathname);
  return u;
 }
 document.addEventListener('click',function(e){
  var t=e.target; if(!t||!t.closest)return;
  var b=t.closest('.add-to-cart-button, .sticky-add-to-cart__button, .bob-cc');
  if(!b)return;
  e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
  if(b.classList.contains('bob-cc')){
   var card=b.closest('product-card, .product-card');
   var a=card?card.querySelector('a.product-card__link, a[href*="/products/"]'):null;
   location.href=a?a.getAttribute('href'):'/pages/reservierung';
   return;}
  location.href=ziel();
 },true);
 if(location.pathname.indexOf('/cart')===0){location.replace('/pages/reservierung');}
 load();
 document.addEventListener('shopify:section:load',load);
})();
